import { FC } from "react";
import { useStyles } from "./styles";
import { LineChart, ChartsGrid } from "@mui/x-charts";
import { Box } from "@material-ui/core";

interface LineChartTempProps {
  dataset: any;
  xAxis: any;
  series: any;
  margin: any;
  height: number;
  slotProps: any;
  sx?:any
}

export const LineChartElem: FC<LineChartTempProps> = ({
  dataset,
  xAxis,
  series,
  margin,
  height,
  slotProps,
  sx
}) => {
  const classes = useStyles();

  return (
    <Box className={classes.chartBox}>
      <LineChart
        dataset={dataset}
        className={classes.lineChart}
        xAxis={xAxis}
        series={series}
        margin={margin}
        height={height}
        slotProps={slotProps}
        sx={sx}
      >
        <ChartsGrid horizontal />
      </LineChart>
    </Box>
  );
};
